// extracted by mini-css-extract-plugin
export default {"container":"SectionDivider_container__gFVKQ"};